import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const PenIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="pen" ref={ref} {...props}>
      <path d="M21.82,9,16.55,14.3c-2.54,2.54-7.83,4.4-8,4.48a.75.75,0,0,1-.78-.18L6.64,17.52l0,0-.06,0L5.47,16.35a.75.75,0,0,1-.18-.77c.08-.23,2-5.52,4.49-8l5.27-5.28a.75.75,0,0,1,1.06,0,.74.74,0,0,1,0,1.06L10.84,8.59c-1.9,1.9-3.47,5.75-4,7l.75.75,0,0s0,0,0,0l.74.74c1.3-.49,5.15-2.06,7.05-4L20.76,8a.75.75,0,0,1,1.06,0A.74.74,0,0,1,21.82,9Zm-6.46.79L19.14,6A.75.75,0,0,0,18.08,5L14.3,8.75a.75.75,0,0,0,0,1.06.74.74,0,0,0,.53.22A.73.73,0,0,0,15.36,9.81ZM2.9,19.75c-.2.62-.3,1,0,1.33s.64.21,1.33,0,2.17-.81,2.17-.81L3.75,17.62S3.1,19.12,2.9,19.75Z" />
    </Icon>
  ),
) as IconWithRender;

PenIcon.displayName = 'PenIcon';
PenIcon.renderIcon = (props) => <PenIcon {...props} />;
export default PenIcon;
